export default __webpack_public_path__ + "22561f7fc2db1baa7b12bb94a665a56d.png";